import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Box, Grid, Typography, alpha, Divider } from "@mui/material";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import IdentityVerificationDocumentSecond from "./IDDocumentSecond";
import { validateFile } from ".";
import { useSelector } from "react-redux";
import { ContainedButton } from "../../Common/Buttons";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

const IdentityVerificationDocument = ({
  handleSteps,
  handleBack,
  userDetails,
  steps,
  setIsloading,
}) => {
  const { btncolor } = useSelector((state) => state);
  const [payload, setPayload] = useState({});
  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: "onChange",
  });

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setValue("addressProof", e.target.files);
    await trigger("addressProof");
  };

  const onSubmit = async (data) => {
    console.log("dtaatata", data?.addressProof[0]);
    const updatedPayload = {
      addressProof: data?.addressProof[0],
    };
    setPayload(updatedPayload);

    if (updatedPayload) {
      handleSteps();
      reset();
    }
  };

  return (
    <>
      {steps === 5 && (
        <Box sx={card}>
          {/* Step Header */}
          <Box sx={stepHeader}>
            <Box sx={{ ...stepBadge, backgroundColor: alpha(btncolor || "#1976d2", 0.12), color: btncolor }}>
              <FolderOpenOutlinedIcon sx={{ fontSize: 18 }} />
            </Box>
            <Box>
              <Typography sx={stepTitle}>Document Upload</Typography>
              <Typography sx={stepCaption}>
                Upload your address proof document
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ borderColor: "rgba(125,125,125,0.13)", mb: 3 }} />

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={fieldLabel}>Address Proof *</Typography>
                <Box sx={uploadCard}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <UploadFileOutlinedIcon sx={{ fontSize: 18, color: btncolor, opacity: 0.8 }} />
                    <Typography sx={{ fontSize: "0.78rem", color: "var(--text-color)", opacity: 0.6 }}>
                      Click to select file
                    </Typography>
                  </Box>
                  <input
                    type="file"
                    style={{ width: "100%", color: "var(--text-color)", fontSize: "0.85rem" }}
                    onChange={(e) => {
                      const fileList = e.target.files;
                      setValue("addressProof", fileList);
                      trigger("addressProof");
                    }}
                    {...register("addressProof", {
                      validate: validateFile,
                    })}
                  />
                </Box>
                {errors.addressProof && (
                  <Typography sx={errorText}>{errors.addressProof.message}</Typography>
                )}
                <Typography sx={hintText}>
                  Utility Bill or Bank Account Statement from the last 3 months. Please do not submit Credit card bill.
                </Typography>
                <Typography sx={hintText}>
                  Accepted: .PNG, .JPEG, .DOC, .DOCX, .JFIF, .HEIC, .PDF, .BMP — MAX 6 MB
                </Typography>
              </Grid>
            </Grid>

            <Box sx={actionRow}>
              <ContainedButton
                variant="contained"
                onClick={handleBack}
                sx={{ ...submitBtn, opacity: 0.85 }}
              >
                Back
              </ContainedButton>
              <ContainedButton type="submit" variant="contained" sx={submitBtn} disabled={!isValid}>
                Next
              </ContainedButton>
            </Box>
          </form>
        </Box>
      )}

      {steps > 5 && (
        <IdentityVerificationDocumentSecond
          handleSteps={handleSteps}
          handleBack={handleBack}
          userDetails={userDetails}
          steps={steps}
          payload={payload}
          setIsloading={setIsloading}
        />
      )}
    </>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const card = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  p: { xs: 2.5, md: 3 },
};

const stepHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  mb: 2.5,
  flexWrap: "wrap",
};

const stepBadge = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const stepTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const stepCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.55,
  mt: 0.2,
};

const fieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "var(--text-color)",
  opacity: 0.55,
  mb: 0.5,
};

const uploadCard = {
  border: "2px dashed rgba(125,125,125,0.3)",
  borderRadius: "10px",
  p: 1.5,
  mt: 0.5,
  backgroundColor: "var(--body-color-less2)",
};

const hintText = {
  fontSize: "0.72rem",
  color: "var(--text-color)",
  opacity: 0.45,
  mt: 0.75,
  lineHeight: 1.5,
};

const errorText = {
  fontSize: "0.72rem",
  color: "#ef4444",
  mt: 0.5,
};

const actionRow = {
  mt: 3.5,
  pt: 2.5,
  borderTop: "1px solid rgba(125,125,125,0.12)",
  display: "flex",
  gap: 1.5,
};

const submitBtn = {
  height: 48,
  px: 4,
  borderRadius: "10px",
  fontWeight: 700,
  fontSize: "0.88rem",
  textTransform: "none",
};

export default IdentityVerificationDocument;
